import { useState } from 'react';
import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';
import { color } from '../../../app/theme';

function IconMoveDown16({ className, disabled }) {
  const [isHover, setIsHover] = useState(false);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <circle
        cx="8"
        cy="8"
        r="8"
        fill={disabled || isHover ? hexRgba(color.$10, 40) : color.$10}
      />
      <mask
        id="IconMoveDown16"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="8"
        height="10"
      >
        <path
          d="m11.19 9.127-2.856 2.857c-.048.048-.096.095-.143.095-.048.048-.143.048-.19.048-.048 0-.144 0-.191-.048-.048-.047-.095-.047-.143-.095L4.81 9.127a.46.46 0 0 1 0-.667.46.46 0 0 1 .667 0l2.047 2.048V4.032c0-.286.19-.476.476-.476s.477.19.477.476v6.476l2.047-2.048a.46.46 0 0 1 .667 0 .46.46 0 0 1 0 .667z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#IconMoveDown16)">
        <path fill="#fff" d="M1.333 1.333h13.333v13.333H1.333z" />
      </g>
    </svg>
  );
}

IconMoveDown16.defaultProps = {
  className: undefined,
};

IconMoveDown16.propTypes = {
  className: PropTypes.string,
};

export default IconMoveDown16;
